import React, { Component, Fragment } from "react";
import SourceItem from "../model/SourceItem";
import TargetItem from "../model/TargetItem";
import ConnectLineUI from "./ConnectLineUI";
import SourceItemUI from "./SourceItemUI";
import TargetItemUI from "./TargetItemUI";

class ConnectActivityUI extends Component {
  constructor() {
    super();
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.handleResize);
  };

  handleResize = () => {
    let { activity, quizViewer } = this.props;

    activity.lineList.map((line, index) => {
      // this.linesParent.removeChild(line.lineHtml)

      line.createHtml();
    });
  };

  render = () => {
    let { activity, quizViewer } = this.props;
    let { sourceItemList, targetItemList, sourceType, targetType } =
      activity.ConnectContainerModel;
    let sourceTypeName = "";
    if (sourceType == 0) sourceTypeName = "Text";
    else if (sourceType == 1) sourceTypeName = "Image";
    else if (sourceType == 2) sourceTypeName = "Text & Image";

    let TargetTypeName = "";
    if (targetType == 0) TargetTypeName = "Text";
    else if (targetType == 1) TargetTypeName = "Image";
    else if (targetType == 2) TargetTypeName = "Text & Image";

    return (
      <Fragment>
        <div style={{ position: "relative" }} className="row">
          <div
            style={{ width: "auto", display: "inline-block" }}
            className="align-self-center"
          >
            {sourceItemList.map((sourceItem, index) => {
              return (
                <div key={index} className="align-self-center">
                  <SourceItemUI
                    ConnectContainerModel={activity.ConnectContainerModel}
                    quizViewer={quizViewer}
                    sourceItem={sourceItem}
                    activity={activity}
                  />
                </div>
              );
            })}
          </div>
          <div style={{ width: "300px", display: "inline-block" }}></div>

          <div
            style={{ width: "auto", display: "inline-block" }}
            className="align-self-center"
          >
            {targetItemList.map((targetItem, index) => {
              return (
                <div className="align-self-center" key={index}>
                  <TargetItemUI
                    ConnectContainerModel={activity.ConnectContainerModel}
                    quizViewer={quizViewer}
                    targetItem={targetItem}
                    activity={activity}
                  />
                </div>
              );
            })}
          </div>

          {activity.lineList.map((line, index) => {
            return (
              <Fragment key={index}>
                <ConnectLineUI
                  quizViewer={quizViewer}
                  activity={activity}
                  connectLine={line}
                />
              </Fragment>
            );
          })}
        </div>{" "}
        {/*    <Fragment>
                <div style={{ position: "relative" }}>

                    {
                        activity.lineList.map((line, index) => {
                            return (
                                <Fragment key={index}>
                                    <ConnectLineUI quizViewer={quizViewer}   activity={activity} connectLine={line} />
                                </Fragment>
                            )
                        })
                    }

                    <div style={{ width: "auto", display: "inline-block" }}>

                        {sourceItemList.map((sourceItem, index) => {
                            return (
                                <div key={index} className="align-self-center">
                                    <SourceItemUI
                                        ConnectContainerModel={activity.ConnectContainerModel}
                                        quizViewer={quizViewer}
                                        sourceItem={sourceItem}
                                        activity={activity} />
                                </div>
                            )
                        })
                        }
                    </div>
                    <div style={{ width: "300px", display: "inline-block" }}></div>


                    <div style={{ width: "auto", display: "inline-block" }}>

                        {targetItemList.map((targetItem, index) => {
                            return (
                                <div className="align-self-center" key={index}  >
                                    <TargetItemUI
                                        ConnectContainerModel={activity.ConnectContainerModel}
                                        quizViewer={quizViewer}
                                        targetItem={targetItem}
                                        activity={activity} />
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </Fragment> */}
      </Fragment>
    );
  };
}

export default ConnectActivityUI;
